import { useNavigate } from 'react-router-dom';
import React from 'react';

/**
 * Hook to navigate while preserving language prefix in URL
 */
export const useLanguageNavigate = () => {
  const navigate = useNavigate();

  const languageNavigate = (path: string, options?: { replace?: boolean }) => {
    // Navigate normally without language prefix
    navigate(path, options);
  };

  return languageNavigate;
};

/**
 * Component to handle Navigate
 */
export const LanguageNavigate: React.FC<{ to: string; replace?: boolean }> = ({ to, replace = false }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate(to, { replace });
  }, [navigate, to, replace]);

  return null;
};
